import { BenefitsReconciliationRunStates } from "@oysterhr/schema"

const IN_PROGRESS_STATUSES = [
  BenefitsReconciliationRunStates.InProgress,
  BenefitsReconciliationRunStates.Requested,
]

export function isReconciliationRunning(status?: BenefitsReconciliationRunStates) {
  return !!status && IN_PROGRESS_STATUSES.includes(status)
}
